import script from "./LoadingComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingComponent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__